import { FullPageCard } from '@/app/components'
import { useUtilityConnectionViewModel } from './UtilityConnection.viewmodel'
import { match } from 'ts-pattern'
import {
  Button,
  ButtonVariant,
  Icon,
  LoadingAnimation,
  Text,
} from '@/components'

export default function UtilityConnection() {
  const { connectionStatus, onButtonClick } = useUtilityConnectionViewModel()
  const icon = match(connectionStatus)
    .with('loading', () => <LoadingAnimation type="falling" />)
    .with('success', () => (
      <div className="flex items-center justify-center bg-base-green-700 p-3 rounded-full">
        <Icon name="JustCheck" className="text-white" />
      </div>
    ))
    .with('error', () => <Icon name="Frown" className="text-white" />)
    .exhaustive()
  const buttonText = match(connectionStatus)
    .with('loading', () => 'Cancel')
    .with('success', () => 'Continue')
    .with('error', () => 'Retry')
    .exhaustive()
  const buttonVariant = match(connectionStatus)
    .with('loading', () => 'secondary')
    .with('success', () => 'primary')
    .with('error', () => 'primary')
    .exhaustive() as ButtonVariant
  const description = match(connectionStatus)
    .with('loading', () => 'Hold tight...we’re finishing up your connection.')
    .with(
      'success',
      () => 'Great! You successfully connected your utility account.',
    )
    .with(
      'error',
      () => 'Oh no! Something went wrong. Please go back and try again.',
    )
    .exhaustive()
  return (
    <FullPageCard>
      <section className="flex flex-col gap-8 w-full h-full justify-center items-center">
        {icon}
        <Text variant="h3" className="text-center">
          {description}
        </Text>
        <Button
          id="utility-connection-action"
          variant={buttonVariant}
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </section>
    </FullPageCard>
  )
}
